<div class="main">
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <table mat-table [dataSource]="abandon">
        <ng-container matColumnDef="plugType">
            <mat-header-cell *matHeaderCellDef> Tipo de Tapón </mat-header-cell>
            <mat-cell *matCellDef="let item"> {{ item.plugType }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdTopStage">
            <mat-header-cell *matHeaderCellDef> MD Tope <br>Programado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item"><span class="table-numbers-right-align"> {{item.mdTopStage | number:
          '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdBaseStage">
            <mat-header-cell *matHeaderCellDef> MD Base <br>Programado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item"><span class="table-numbers-right-align"> {{item.mdBaseStage | number:
          '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="topCheck">
            <mat-header-cell *matHeaderCellDef> ¿Constató <br>tope? </mat-header-cell>
            <mat-cell *matCellDef="let item, let i = index">
                <mat-slide-toggle [disabled]="readOnlyContent" [checked]="item.topCheck" [(ngModel)]="abandon[i].topCheck" (change)="enableSaveButton(i, abandon[i].comment, $event.checked, abandon[i].mdTopChecked, abandon[i].supportPlugType, abandon[i].mdSupportPlugTop)">
                    {{item.topCheck ? 'Si' : 'No'}}
                </mat-slide-toggle>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdTopChecked">
            <mat-header-cell *matHeaderCellDef> MD Tope <br>Constatado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="abandon[i].mdTopChecked" (keyup)="enableSaveButton(i, abandon[i].comment, abandon[i].topCheck, abandon[i].mdTopChecked, abandon[i].supportPlugType, abandon[i].mdSupportPlugTop)" #mdTopChecked
                    />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="supportPlugType">
            <mat-header-cell *matHeaderCellDef> Tipo de Tapón <br>de Soporte </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="text" [(ngModel)]="abandon[i].supportPlugType" (keyup)="enableSaveButton(i, abandon[i].comment, abandon[i].topCheck, abandon[i].mdTopChecked, abandon[i].supportPlugType, abandon[i].mdSupportPlugTop)"
                        #supportPlugType />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdSupportPlugTop">
            <mat-header-cell *matHeaderCellDef> MD Tope Tapón <br>de Soporte [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="abandon[i].mdSupportPlugTop" (keyup)="enableSaveButton(i, abandon[i].comment, abandon[i].topCheck, abandon[i].mdTopChecked, abandon[i].supportPlugType, abandon[i].mdSupportPlugTop)"
                        #mdSupportPlugTop />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index" [ngClass]="'mat-column-save'">
                <span class="row-buttons">
          <button mat-mini-fab (click)="openComments(abandon[i].comment, i, $event, readOnlyContent);" class="comment-ho-icon">
            <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
            <div class="circle-comments" *ngIf="abandon[i].comment"></div>
            <span class = "comment">Comentar</span>
          </button>
                </span>
                <button mat-mini-fab (click)="saveAbandon(item, i);" class="save-ho-icon" [disabled]="isDisabled[i]">
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="8">
            <div class="footer">
                <div class="footer-no-data">No se encontraron datos.</div>
                <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
            </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
    </table>
</div>
    <div>
        <p class="title-section">Tapones Adicionales</p>
    </div>
<div class="plugs">
    <table mat-table [dataSource]="additionalPlugs">
        <ng-container matColumnDef="plugType">
            <mat-header-cell *matHeaderCellDef> Tipo de Tapón </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index"> 
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="text" [(ngModel)]="additionalPlugs[i].plugType" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])"
                        #plugType />
                        <mat-hint class="alert" *ngIf="item.plugType == null">
                            Requerido
                        </mat-hint>
                </mat-form-field>    
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdTopStage">
            <mat-header-cell *matHeaderCellDef> MD Tope <br>Programado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="additionalPlugs[i].mdTopStage" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])" #mdTopStage
                    />
                   <mat-hint class="alert" *ngIf="item.mdTopStage == null">
                        Requerido
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdBaseStage">
            <mat-header-cell *matHeaderCellDef> MD Base <br>Programado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="additionalPlugs[i].mdBaseStage" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])" #mdBaseStage
                    />
                    <mat-hint class="alert" *ngIf="item.mdBaseStage == null">
                        Requerido
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="topCheck">
            <mat-header-cell *matHeaderCellDef> ¿Constató <br>tope? </mat-header-cell>
            <mat-cell *matCellDef="let item, let i = index">
                <mat-slide-toggle [disabled]="readOnlyContent" [checked]="item.topCheck" [(ngModel)]="additionalPlugs[i].topCheck" (change)="enablePlugsSaveButton(i, additionalPlugs[i])">
                    {{item.topCheck ? 'Si' : 'No'}}
                </mat-slide-toggle>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdTopChecked">
            <mat-header-cell *matHeaderCellDef> MD Tope <br>Constatado [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="additionalPlugs[i].mdTopChecked" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])" #mdTopChecked
                    />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="supportPlugType">
            <mat-header-cell *matHeaderCellDef> Tipo de Tapón <br>de Soporte </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="text" [(ngModel)]="additionalPlugs[i].supportPlugType" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])"
                        #supportPlugType />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdSupportPlugTop">
            <mat-header-cell *matHeaderCellDef> MD Tope Tapón <br>de Soporte [m] </mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index">
                <mat-form-field>
                    <input matInput [disabled]="readOnlyContent" type="number" [(ngModel)]="additionalPlugs[i].mdSupportPlugTop" (keyup)="enablePlugsSaveButton(i, additionalPlugs[i])"
                        #mdSupportPlugTop />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let item; let i = index" [ngClass]="'mat-column-save'">
                <span class="row-buttons">
          <button mat-mini-fab (click)="openCommentsPlug(additionalPlugs[i].comment, i, $event, readOnlyContent);" class="comment-ho-icon">
            <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
            <div class="circle-comments" *ngIf="additionalPlugs[i].comment"></div>
            <span class = "comment">Comentar</span>
          </button>
                </span>
        <button
        mat-button
        [ngClass]="{ ready: true }"
        [disabled]="isDisabledPlugs[i]"
        (click)="saveAdditionalPlug(item, i);"
        >
        LISTO
        </button>
        <button *ngIf="item.additionalPlugId"
        mat-icon-button
        [ngClass]="{ remove: true }"
        [disabled]="readOnlyContent"
        (click)="deleteAdditionalPlugs(item.additionalPlugId);"
        >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
</div>
    
